<div *ngIf="action === 'new' || action === 'offer'" [ngClass]="{mmao__offer: action === 'offer'}">
  <form [formGroup]="offerFormGroup" (ngSubmit)="submit()">
    <mat-form-field class="mmao__offer__formfield">
      <input
        matInput
        id="offer-price"
        class="vc-form-text__input"
        [formControl]="offerFormControl"
        type="number"
        [min]="min"
        [max]="max"
        step="1"
        required
        (focus)="setOfferFormControlFocus()"
        i18n-placeholder="
           {{ offerFormControl.value !== null || offerFormControl.valid ? action === 'new' ?
          '@@MMAO.POPIN.OTHER_MSG.YOUR_OFFER' : '@@MMAO.POPIN.OTHER_MSG.YOUR_COUNTER_OFFER' :
          '@@MMAO.INPUT_PLACEHOLDER.NUMBER' }}
        "
        [placeholder]="
          offerFormControlFocused || offerFormControl.dirty || offer.touched
            ? action === 'new'
              ? 'Your offer'
              : 'Your counter offer'
            : 'Amount'
        "
      />
      <mat-error *ngIf="offerFormControl.touched || offerFormControl.invalid">
        <ng-container i18n="@@MMAO.POPIN.OTHER_MSG.OFFER_MAX_MIN"
          >Please enter a price between {{ min | currency: currency:'symbol':'1.0-2' }} and
          {{ max | currency: currency:'symbol':'1.0-2' }}</ng-container
        >
      </mat-error>

      <span matSuffix>{{ currencySymbol }}</span>
    </mat-form-field>

    <div *ngIf="isLastOffer" class="mmao__offer__last-offer-alert" i18n="@@MMAO.POPIN.OTHER_MSG.RESPONSE_LAST_OFFER">
      Please note, this is your final offer.
    </div>
    <div class="clearfix">
      <!-- NEW OFFER CASE -->
      <ng-container *ngIf="action === 'new'">
        <button
          type="submit"
          class="vc-btn vc-btn--medium vc-btn--full vc-btn--primary"
          [disabled]="!offerFormGroup.valid || (formSubmitted && !hasError)"
          i18n="@@MMAO.CTA.SEND"
        >
          Send
        </button>
      </ng-container>

      <!-- MAKE OFFER CASE -->
      <ng-container *ngIf="action === 'offer'">
        <button
          type="button"
          class="vc-btn vc-btn--medium vc-btn--secondary mmao__offer__button--half"
          (click)="cancel()"
          i18n="@@MMAO.CTA.CANCEL"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="vc-btn vc-btn--medium vc-btn--primary mmao__offer__button--half"
          [disabled]="!offerFormGroup.valid || (formSubmitted && !hasError)"
          i18n="@@MMAO.CTA.SEND"
        >
          Send
        </button>
      </ng-container>
    </div>
  </form>
</div>
